import { createContext, useContext } from "react";

export type DrawerManagerContextType = {
  drawerStack: string[];
  openDrawer: (id: string) => void;
  closeDrawer: (id: string) => void;
  isTopDrawer: (id: string) => boolean;
  isBottomDrawer: (id: string) => boolean;
  clearAllOnClose: boolean;
};

export const DrawerManagerContext = createContext<
  DrawerManagerContextType | undefined
>(undefined);

export const useDrawerManager = () => {
  const context = useContext(DrawerManagerContext);

  if (!context) {
    return null;
  }
  return context;
};
